import { render, staticRenderFns } from "./SvgMarkings.vue?vue&type=template&id=af51eac4"
import script from "./SvgMarkings.vue?vue&type=script&lang=js"
export * from "./SvgMarkings.vue?vue&type=script&lang=js"
import style0 from "./SvgMarkings.vue?vue&type=style&index=0&id=af51eac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports